<template>
  <div class="dashboard-status-bar">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card :color=pickColor(errorCount)>
            <v-card-title class="white--text">
              <v-icon color="white" v-if="layoutInformation.leftGraph" @click="leftFoldGraph">chevron_left</v-icon>
              <v-icon color="white" v-else @click="leftExpandGraph">chevron_right</v-icon>
              &nbsp;전체 {{ errorCount.total }}개 현장 중 {{ errorCount.error }}개 에러
              <v-spacer/>
              <v-icon color="white" v-if="layoutInformation.downGraph" @click="downFoldGraph">expand_less</v-icon>
              <v-icon color="white" v-else @click="downExpandGraph">expand_more</v-icon>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'dashboardStatusBar',
    props: {
      errorCount: {
        type: Object,
        required: true
      },
      selectedSiteStatus: {
        type: Object,
        required: true
      },
      layoutInformation: {
        type: Object,
        required: true
      },
      charts: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
      }
    },
    methods: {
      pickColor(errorCount) {
        if (errorCount.error === 0) {
          return 'green';
        } else {
          return 'red';
        }
      },
      downExpandGraph() {
        this.layoutInformation.leftGraph = false;
        this.layoutInformation.downGraph = true;
        $cookies.set('siengLayoutInformation', this.layoutInformation, '1825d');
        this.resetCharts();
        this.refreshGraphs();
      },
      downFoldGraph() {
        this.layoutInformation.downGraph = false;
        this.layoutInformation.leftGraph = false;
        $cookies.set('siengLayoutInformation', this.layoutInformation, '1825d');
      },
      leftExpandGraph() {
        this.layoutInformation.downGraph = false;
        this.layoutInformation.leftGraph = true;
        $cookies.set('siengLayoutInformation', this.layoutInformation, '1825d');
        this.resetCharts();
        this.refreshGraphs();
      },
      leftFoldGraph() {
        this.layoutInformation.leftGraph = false;
        this.layoutInformation.downGraph = false;
        $cookies.set('siengLayoutInformation', this.layoutInformation, '1825d');
      },
      resetCharts() {
        console.log("reset charts ...");
        Object.values(this.charts.down).forEach(chart => chart.destroy());
        Object.values(this.charts.left).forEach(chart => chart.destroy());
      },
      printDebugLog(target) {
        console.dir(target);
      },
      refreshGraphs() {
        this.$bus.$emit('refreshGraphs');
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      }
    }
  }
</script>